export default __webpack_public_path__ + "static/media/2479.4158a6d0.svg";